// Open Problems mock data (UI-only, v1).
// Mix: 9 problems posted by new "seeker" personas + 3 posted by existing solvers.

export const URGENCY = ["Today", "This week", "This month", "No rush"];

// Every mock problem is tagged isDemo so the frontend can visually mark it
// and disable auth-gated interactions on it.
const _mk = (obj) => ({ isDemo: true, ...obj });

export const OPEN_PROBLEMS = [
  _mk({
    id: "op-01",
    title: "Automate proposal writing for a 3-person agency",
    category: "Content & Creative AI",
    description:
      "We waste a full day per proposal. Want a workflow that turns a discovery-call transcript into a first-draft proposal we only need to polish.",
    postedBy: {
      name: "Rowan Fischer",
      role: "Agency Owner",
      photo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400",
      personId: null,
    },
    datePosted: "2026-02-20",
    urgency: "This week",
    interestedCount: 4,
  }),
  _mk({
    id: "op-02",
    title: "Customer support chatbot that actually knows our docs",
    category: "RAG & Search",
    description:
      "Tried three off-the-shelf bots. All hallucinate. Need someone who's built a support bot on top of internal docs and reduced deflection issues.",
    postedBy: {
      name: "Meera Iyer",
      role: "Head of Support",
      photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400",
      personId: null,
    },
    datePosted: "2026-02-18",
    urgency: "This month",
    interestedCount: 7,
  }),
  _mk({
    id: "op-03",
    title: "Invoice processing pipeline for a small accounting firm",
    category: "AI Agents & Automation",
    description:
      "500+ invoices/month arrive as PDFs and scanned images. Want to extract line items, categorise and push to our ledger with a human review step.",
    postedBy: {
      name: "Hiro Sato",
      role: "Ops Manager",
      photo: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400",
      personId: null,
    },
    datePosted: "2026-02-15",
    urgency: "This month",
    interestedCount: 3,
  }),
  _mk({
    id: "op-04",
    title: "Build a repeatable SEO content workflow",
    category: "Content & Creative AI",
    description:
      "Solo founder. Need a workflow to publish 2 quality SEO posts per week without becoming a full-time writer. Looking for tooling + prompt patterns.",
    postedBy: {
      name: "Anouk de Vries",
      role: "Solo Founder",
      photo: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=400",
      personId: null,
    },
    datePosted: "2026-02-22",
    urgency: "No rush",
    interestedCount: 6,
  }),
  _mk({
    id: "op-05",
    title: "Prompt-injection defense for a public-facing agent",
    category: "Evals & Reliability",
    description:
      "Our support agent is going public next month. Need help hardening it against prompt injection and building an eval suite before launch.",
    postedBy: {
      name: "Amara Johnson",
      role: "Head of Operations",
      photo: "https://images.pexels.com/photos/29852895/pexels-photo-29852895.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      personId: "amara-johnson",
    },
    datePosted: "2026-02-23",
    urgency: "Today",
    interestedCount: 2,
  }),
  _mk({
    id: "op-06",
    title: "Voice agent for booking dental appointments",
    category: "AI Agents & Automation",
    description:
      "Small dental practice. Want a phone agent that handles routine bookings and reschedules. Must feel natural and hand off cleanly when confused.",
    postedBy: {
      name: "Kwame Boateng",
      role: "Clinic Owner",
      photo: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400",
      personId: null,
    },
    datePosted: "2026-02-10",
    urgency: "This month",
    interestedCount: 5,
  }),
  _mk({
    id: "op-07",
    title: "Design an AI-native onboarding for a fintech app",
    category: "AI Product Design",
    description:
      "Current onboarding is a 7-step form. Want to prototype a conversational alternative that still collects the compliance data we need.",
    postedBy: {
      name: "Julian Park",
      role: "Indie Hacker",
      photo: "https://images.unsplash.com/photo-1517256673644-36ad11246d21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxjcmVhdGl2ZSUyMGNhc3VhbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NDgwOTYzMXww&ixlib=rb-4.1.0&q=85",
      personId: "julian-park",
    },
    datePosted: "2026-02-12",
    urgency: "This week",
    interestedCount: 8,
  }),
  _mk({
    id: "op-08",
    title: "Video ad variants from a single script",
    category: "Generative Media",
    description:
      "I have one ad script. I want 8 short video variants (different hooks, different pacing) generated so I can test creative at scale.",
    postedBy: {
      name: "Talia Rosenberg",
      role: "Performance Marketer",
      photo: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=400",
      personId: null,
    },
    datePosted: "2026-02-19",
    urgency: "This week",
    interestedCount: 4,
  }),
  _mk({
    id: "op-09",
    title: "Personalised tutoring bot for GCSE physics",
    category: "AI for Teaching & Learning",
    description:
      "Tutor building a small side product. Want an AI tutor that adapts explanations to a student's answers, not just quizzes them.",
    postedBy: {
      name: "Grace Adekunle",
      role: "Private Tutor",
      photo: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=400",
      personId: null,
    },
    datePosted: "2026-02-08",
    urgency: "No rush",
    interestedCount: 2,
  }),
  _mk({
    id: "op-10",
    title: "Cut our inference bill without dropping quality",
    category: "AI Research & Applied ML",
    description:
      "We're spending $18k/month on GPT-4 class calls. Need help with routing, caching and possibly a distilled model for our top use cases.",
    postedBy: {
      name: "Rafael Costa",
      role: "CTO",
      photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400",
      personId: null,
    },
    datePosted: "2026-02-14",
    urgency: "This month",
    interestedCount: 9,
  }),
  _mk({
    id: "op-11",
    title: "Second-brain RAG over 8 years of Notion",
    category: "RAG & Search",
    description:
      "I have thousands of Notion pages I can't find anything in. Want a private RAG index I can query in natural language.",
    postedBy: {
      name: "Iris Nakamura",
      role: "Writer",
      photo: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400",
      personId: null,
    },
    datePosted: "2026-02-16",
    urgency: "No rush",
    interestedCount: 3,
  }),
  _mk({
    id: "op-12",
    title: "Ship an eval harness before we hit production",
    category: "Evals & Reliability",
    description:
      "Small team, no eval infra. Need help setting up a golden set, diff view and CI check for prompt/model changes before we ship.",
    postedBy: {
      name: "Maya Chen",
      role: "Founding Engineer",
      photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwaGVhZHNob3QlMjBkaXZlcnNlfGVufDB8fHx8MTc4NDgwOTYzMXww&ixlib=rb-4.1.0&q=85",
      personId: "maya-chen",
    },
    datePosted: "2026-02-21",
    urgency: "This week",
    interestedCount: 6,
  }),
];
